import React, { PureComponent, PropTypes } from 'react';

import BookPrice from 'components/BookPrice/BookPrice';
import './SeatListRowPriceHeader.scss';

export default class SeatListRowPriceHeader extends PureComponent {
  static propTypes = {
    rowRepresentation: PropTypes.arrayOf(
      PropTypes.shape({
        price: PropTypes.number,
        count: PropTypes.number,
        isSeat: PropTypes.bool,
      }),
    ).isRequired,
    rowWidth: PropTypes.number.isRequired,
  };

  render() {
    const { rowRepresentation, rowWidth } = this.props;

    return (
      <p className="seat-list-row-price-header">
        { rowRepresentation.map((item, index) => {
          const style = {
            width: `${(100 / rowWidth) * item.count}%`,
          };

          return (
            <span key={index} style={style} className="seat-list-row-price-header__item-wrapper">
              <span className={`seat-list-row-price-header__item seat-list-row-price-header__item--${item.isSeat ? 'seat' : 'aisle'}`}>
                { typeof item.price === 'number' && (
                  <BookPrice price={item.price} isRounded />
                )}
              </span>
            </span>
          );
        })}
      </p>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/SeatListRowPriceHeader.jsx
 **/